import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Add, Ballot, BeenhereRounded, Close, Edit } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import stylesAlert from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { Toasty, useToasty } from 'hooks/Toasty';
import SweetAlert from 'react-bootstrap-sweetalert';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsFindBy, wsPost } from 'services/WService.js';
import { WithApp } from 'contexts/appContext';

import Filter from 'components/Tvendo/Common/FilterCustom';
import { currency, nPercent } from 'hooks/Pipe';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import SaleOrderDetail from './SaleOrderDetail';
import resultState from './stateMigrate';
import { useModal } from 'hooks/useModal';
import EditModal from './EditModal';
import { Tooltip } from '@material-ui/core';
import OrderTransactionModal from 'components/Tvendo/Order/OrderTransactionModal';

const useStyles = makeStyles({
  ...stylesAlert,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    fontSize: '18px',
  },
  totals: {
    marginTop: '15px',
    fontWeight: 'bold',
  },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Tipo', accessor: 'U_SYP_MDTD', width: 100 },
  { Header: 'Serie', accessor: 'U_SYP_MDSD', width: 100 },
  { Header: 'Número', accessor: 'U_SYP_MDCD', width: 100 },
  { Header: 'Comentario', accessor: 'comments', width: 150 },
  { Header: 'Fec. Pedido', accessor: 'date_order', width: 150 },
  { Header: 'Vendedor', accessor: 'seller' },
  { Header: 'Cód. Cliente', accessor: 'CardCode', width: 120 },
  { Header: 'Nombre cliente', accessor: 'CardName' },
  { Header: 'Dirección', accessor: 'address', width: 300 },
  { Header: 'Importe', accessor: 'total_order', width: 120, align: 'right' },
  { Header: 'Venta', accessor: 'sale_type', width: 80 },
  { Header: 'Tipo doc.', accessor: 'documentType', width: 150 },
  { Header: 'Térm. pago', accessor: 'PymntGroup', width: 120 },
  { Header: 'Zona', accessor: 'base_zone_description', width: 120 },
  { Header: 'Ruta', accessor: 'base_route_description', width: 300 },
  { Header: 'Mesa', accessor: 'base_bureau_description', width: 200 },
  { Header: 'Almacén', accessor: 'base_warehouse_description', width: 150 },
  { Header: 'Canal', accessor: 'base_canal_description', width: 150 },
  { Header: 'Prioridad', accessor: 'base_reason_description_priority', width: 150 },
  { Header: 'Lista precio', accessor: 'ListName', width: 170 },
  { Header: 'Fza. Venta', accessor: 'base_sale_force_id', width: 120 },
  { Header: 'Paquetes', accessor: 'packages', width: 120, align: 'center' },
  { Header: 'Unidades', accessor: 'units', width: 120, align: 'center' },
  { Header: 'Mto. Bruto', accessor: 'gross_amount_without_igv', width: 120, align: 'right' },
  { Header: '%Descuento', accessor: 'discount', width: 120, align: 'center' },
  { Header: 'Estado', accessor: 'state_migrate', width: 120 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function SaleOrder(props) {
  const classes = useStyles();
  const { title, originType, excelName, permission, endpoint = 'sale/order' } = props;
  const location = useLocation();
  const navigate = useNavigate();

  const [alert, setAlert] = useState(null);
  const [notify, showNotify] = useToasty(); //notificación despues de las

  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState({});
  const [totals, setTotals] = useState(0);
  const [open, setOpen] = useState(false);
  const [idOrder, setIdOrder] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  // Modal de edición
  const [editModel, setEditModalOpen] = useModal();
  const [logModel, setLogModalOpen] = useModal();

  async function getOrders(search) {
    if (originType === 'SO') {
      search.state_migrate = 'X';
    } else if (originType === 'DO') {
      if (search.state !== undefined) {
        search.state_migrate = search.state;
      }
      delete search.state;
    } else if (originType === 'WO') {
      search.state_migrate = 'X';
      search.sale_type = 'O';
    }
    setDataLoading(true);
    let response = await wsFindBy(endpoint, search);
    setDataLoading(false);
    if (response.success) {
      setFilter(search);
      setOrders(response.data);
      let totalOrder = response.data
        .filter((item) => item.state_migrate !== 'A')
        .reduce((a, { total_order }) => a + total_order, 0);
      setTotals(totalOrder);
    }
  }

  function confirmAnnular(orderId) {
    const hideAlert = () => {
      setAlert(null);
    };
    setAlert(
      <SweetAlert
        input
        required={false}
        style={{ display: 'block', marginTop: '-100px' }}
        title={'¿Esta seguro de anular?'}
        onConfirm={(e) => {
          removeOrder(orderId, { ObservacionError: e });
          hideAlert();
        }}
        onCancel={hideAlert}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        Ingrese el motivo por favor :)
      </SweetAlert>,
    );
  }

  async function removeOrder(orderId, data) {
    setDataLoading(true);
    let response = await wsPost(`sale/order/${orderId}/annular`, data);
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      getOrders(filter);
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (open) {
      navigate(`${location.pathname}#${idOrder}`, { replace: true });
    }
  }, [open]);

  useEffect(() => {
    if (location.hash !== '') {
      setOpen(true);
      setIdOrder(location.hash.substring(1));
    }
  }, []);

  return (
    <>
      <Toasty action={notify} />

      <EditModal
        model={editModel}
        setOpen={setEditModalOpen}
        showNotify={showNotify}
        setOrders={setOrders}
      />

      {alert}
      {open ? (
        <ModalFull
          title="Detalles"
          open={open}
          setOpen={(open) => {
            setOpen(open);
            navigate(`${location.pathname}`, { replace: true });
          }}
        >
          <SaleOrderDetail
            idOrder={idOrder}
            showNotify={showNotify}
            reload={() => {
              setOpen(false);
              getOrders(filter);
            }}
          />
        </ModalFull>
      ) : undefined}

      <OrderTransactionModal model={logModel} setOpen={setLogModalOpen} entity="sale/order" />

      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={permission.store}
            component={
              <CardIcon color={props.themeContext.buttonColor}>
                <BeenhereRounded style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <Link to="0">
              <CardIcon pointer="true" color="success">
                <Add style={{ color: 'white' }} />
              </CardIcon>
            </Link>
          </AllowedGuard>
          <div style={{ display: 'flex', justifyContent: 'space-between', color: 'black' }}>
          
            <span className={classes.cardIconTitle}>{title}{dataLoading && <LoadingSpinner />}</span>
            <div className={classes.totals}>
              <span>Importe: {currency(totals)}</span>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <Filter
            getFilter={getOrders}
            zone
            dateRange
            diffRange={0}
            seller
            state={originType === 'DO'}
            optionValues={['X', 'P', 'G', 'W', 'S', 'R', 'F', 'D', 'A']}
            nameOptions={[
              'Programable',
              'Programado',
              'Facturado SAP',
              'Reparto',
              'Sin stock',
              'Reparto',
              'Finalizado',
              'Borrador',
              'Anulado',
            ]}
            buttonSearch
          />
          <ReactTable
            excelName={excelName}
            defaultWidth={4000}
            formatDate="DD/MM/YYYY HH:mm:ss"
            columns={columns}
            data={orders.map((order, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={permission.show}>
                      <Button
                        justIcon
                        round
                        simple
                        onClick={() => {
                          setOpen(!open);
                          setIdOrder(order.id);
                        }}
                        color={props.themeContext.buttonColor}
                      >
                        <VisibilityIcon />
                      </Button>
                    </AllowedGuard>
                    {originType === 'SO' ? (
                      <AllowedGuard permission={permission.delete}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorDanger}
                          onClick={() => {
                            confirmAnnular(order.id);
                          }}
                        >
                          <Close />
                        </Button>
                      </AllowedGuard>
                    ) : undefined}

                    {originType === 'DO' && (
                      <AllowedGuard permission={permission.edit}>
                        <Button
                          justIcon
                          round
                          simple
                          color={'warning'}
                          onClick={() => {
                            setEditModalOpen(order);
                          }}
                        >
                          <Edit />
                        </Button>
                      </AllowedGuard>
                    )}
                    <Tooltip title="Logs">
                      <Button
                        justIcon
                        round
                        simple
                        color="warning"
                        onClick={() => {
                          setLogModalOpen(order);
                        }}
                      >
                        <Ballot />
                      </Button>
                    </Tooltip>
                  </div>
                ),
                U_SYP_MDTD: order.U_SYP_MDTD === '03' ? 'Boleta' : 'Factura',
                U_SYP_MDSD: order.U_SYP_MDSD,
                U_SYP_MDCD: order.U_SYP_MDCD,
                comments: order.comments || ' - ',
                date_order: order.date_order,
                seller: order.SlpCode + ' - ' + order.SlpName || '-',
                CardCode: order.CardCode,
                CardName: order.CardName,
                address: order.Address2,
                total_order: currency(order.total_order),
                sale_type:
                  order.sale_type === 'O' ? 'Oficina' : order.sale_type === 'S' ? 'Campo' : '-',
                documentType: order.base_document_type_description,
                PymntGroup: order.PymntGroup,
                base_zone_description: order.base_zone_description,
                base_route_description:
                  order.base_route_code + ' - ' + order.base_route_description || '-',
                base_bureau_description: order.base_bureau_description,
                base_warehouse_description: order.base_warehouse_description,
                base_canal_description: order.base_canal_description,
                base_reason_description_priority: order.base_reason_description_priority,
                ListName: `${order.ListNum || ''} - ${order.ListName || ''}`,
                base_sale_force_id: order.base_sale_force_id,
                packages: order.packages,
                units: order.units,
                gross_amount_without_igv: order.gross_amount_without_igv,
                discount: nPercent(order.discount),
                state_migrate: resultState(order.state_migrate),
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
